<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2022-09-14 16:34:59
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2024-02-02 17:50:40
 * @FilePath: \合联\oms\src\view\users\client\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    ref="table"
  >
    <template #ADDMODAL="{ visible, params, close }">
      <AddModal
        v-if="visible"
        :isBank="params.isBank"
        :close="close"
        :selectData="selectData"
        :row="params"
      />
    </template>
    <template #Freight="{ visible, params, close }">
      <ClientFreight v-if="visible" :close="close" :rows="params" />
    </template>
    <template #robot="{ visible, params, close }">
      <robot v-if="visible" :close="close" :rows="params" />
    </template>
    <template #Contract="{ visible, params, close }">
      <ClientContract
        v-if="visible"
        :close="close"
        :clientId="params.id"
        :clientName="params.account"
        :rows="params"
        ref="contract"
      />
    </template>
    <template #Whitelist="{ visible, params, close }">
      <ClientWhitelist v-if="visible" :close="close" :id="params.id" />
    </template>
  </cTable>
</template>

<script>
import {
  add,
  getClient,
  getDetails,
  update,
  del,
  updatePwd,
  getCompanies,
  auditClient,
  getLog,
  saveBatchStatus,
  getClientConfig,
  getBindUser,
  setBindUser,
  showFinance,
  saveUserBindInfo,
  getPlatform,
  getDeliverType,
  fitUserRegUrl,
  batchSetting
} from "@/api/user/client";
import { getWhitelistDetail, updateWhitelist } from "@/api/user/whitelist";
import { getAllService } from "@/api/user/internal";
import { getContractParams } from "@/api/user/contract";

import cTable from "@/base/common/index";
import AddModal from "./modal";
import ClientFreight from "_my/client-freight";
import ClientContract from "./contract";
import ClientWhitelist from "./whitelist";
import { getCurrency } from "@/api/finance/currency";
import robot from "./robot";
export default {
  name: "client",
  components: {
    cTable,
    AddModal,
    ClientFreight,
    ClientContract,
    ClientWhitelist,
    robot
  },
  data() {
    return {
      selectData: {},
      methods: {
        list: params => {
          if (params.startTime)
            params.createTimeRange =
              params.startTime + (params.endTime ? "," + params.endTime : "");
          return getClient(params);
        },
        getDetails,
        del,
        add,
        update,
        getAllService,
        getWhitelistDetail,
        updateWhitelist,
        updatePwd,
        getCompanies,
        auditClient,
        getContractParams,
        getLog,
        saveBatchStatus,
        getClientConfig,
        getBindUser,
        showFinance,
        setBindUser,
        saveUserBindInfo,
        fitUserRegUrl,
        batchSetting
      },
      config: {
        height: 630
      },
      modals: {
        batchSetting: {
          type: "add",
          methods: {
            ok({ row, close }) {
              row.change_value =
                row.type === "setFit"
                  ? row.fit
                  : row.type === "setBillingCycle"
                  ? row.date
                  : row.number;
              this.$page
                .handleRequestMethods("batchSetting", row, true, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$tz("批量设置"),
            modalBind: {
              width: 500
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              fit: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              date: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number"
                }
              ]
            }
          },
          grid: [
            {
              fit: 24,
              date: 24,
              number: 24
            }
          ],
          fields: [
            {
              name: this.$tz("散客"),
              key: "fit",
              component: "Radio",
              options: [
                // YES NO
                { label: this.$tz("是"), value: "YES" },
                { label: this.$tz("否"), value: "NO" }
              ],
              optionsFn: "",
              optionsKey: "",
              bind: {
                border: true
              },
              show() {
                return this.$modal.params.type === "setFit";
              }
            },
            {
              name: this.$tz("结算周期"),
              key: "date",
              component: "Select",
              placeholder: () => this.$tz("结算周期"),
              options: [
                { label: this.$tz("周"), value: "WEEK" },
                { label: this.$tz("月"), value: "MONTH" },
                { label: this.$tz("半月"), value: "HALFMONTH" },
                { label: this.$tz("天"), value: "DAY" }
              ],
              optionsFn: "",
              optionsKey: "",
              default: "",
              show() {
                return this.$modal.params.type === "setBillingCycle";
              }
            },
            {
              name: this.$tz("信用额度"),
              key: "number",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%"
              },
              show() {
                return this.$modal.params.type === "setCreditLimit";
              }
            }
          ]
        },
        robot: {
          contentSlot: "robot",
          config: {
            modalBind: {
              width: 1300,
              draggable: true
            }
          },
          footer: {
            show: () => false
          }
        },
        updateUser: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.id = this.$page.selectAll.map(item => item.id);
              this.$page
                .handleRequestMethods("setBindUser", data, true, true)
                .then(res => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg
                  });
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            modalBind: {
              width: 600
            },
            title: this.$t("batch") + this.$t("setting") + this.$t("personnel"),
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              type: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ],
              staff_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ]
            }
          },
          grid: [{ type: 24 }, { staff_id: 24 }],
          fields: [
            {
              key: "type",
              name: () => this.$t("personnel") + this.$t("type"),
              component: "Select",
              options: [],
              placeholder: () => this.$t("select") + this.$t("type"),
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getClientConfig")
                  ).payload;
                  this.$forceUpdate();
                },
                "on-change"({ row, fields }) {
                  fields.forEach(async item => {
                    if (item.key == "staff_id") {
                      item.options = (
                        await this.$page.handleRequestMethods("getBindUser", {
                          type: row.type
                        })
                      ).payload;
                    }
                    this.$forceUpdate();
                  });
                }
              }
            },
            {
              key: "staff_id",
              name: () => this.$t("correspond") + this.$t("personnel"),
              component: "Select",
              options: [],
              placeholder: () =>
                this.$t("select") + this.$t("correspond") + this.$t("personnel")
            }
          ]
        },
        statusModal: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.id = this.$page.selectAll.map(item => item.id);
              this.$page
                .handleRequestMethods("saveBatchStatus", data)
                .then(res => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg
                  });
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              maskClosable: false
            },
            title:
              this.$t("batch") + this.$t("enable") + "/" + this.$t("disable"),
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              status: [
                {
                  required: true,
                  trigger: "change"
                }
              ]
            }
          },
          grid: [{ status: 24 }],
          fields: [
            {
              key: "status",
              name: () => this.$t("enable") + "/" + this.$t("disable"),
              component: "Radio",
              options: [
                {
                  label: this.$t("enable"),
                  value: "ENABLE"
                },
                {
                  label: this.$t("disable"),
                  value: "DISABLE"
                }
              ],
              bind: {
                border: true
              }
            }
          ]
        },
        shippingStatus: {
          footer: {
            show: () => false
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              maskClosable: true
            },
            title: this.$t("auditOrder"),
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [
            { airway_number: 24 },
            { create_time: 24 },
            { delivery_mode: 24 }
          ],
          fields: [
            {
              key: "airway_number",
              name: () => this.$t("order_number"),
              component: "Input",
              disabled: true
            },
            {
              key: "create_time",
              name: () =>
                this.$t("newest") + this.$t("placeOrder") + this.$t("time"),
              component: "Input",
              disabled: true
            },
            {
              key: "delivery_mode",
              name: () => this.$t("delivery_mode"),
              component: "Input",
              disabled: true
            }
          ]
        },
        audit: {
          footer: {
            show() {
              return this.temp && this.$hasPermission(96);
            }
          },
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData();
              delete data.audit_time;
              delete data.audit_remarks;
              delete data.audit_user_account;
              data.id = row.id;
              // console.log(data);
              // return;
              this.$page.handleRequestMethods("auditClient", data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              maskClosable: true
            },
            title: this.$t("auditOrder"),
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              reason_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ]
            }
          },
          grid: [
            { audit_time: 24 },
            { audit_user_account: 24 },
            { audit_remarks: 24 },
            { audit_status: 24 },
            { reason_id: 24 },
            { days: 24 },
            { u_tag: 24 },
            { remarks: 24 },
            { special_remarks: 24 }
          ],
          fields: [
            {
              key: "days",
              name: () => this.$tz("过N天重新审核"),
              component: "Input",
            },
            {
              key: "audit_time",
              name: () => this.$t("audit_time"),
              component: "Input",
              disabled: true
            },
            {
              key: "audit_user_account",
              name: () => this.$t("audit"),
              component: "Input",
              disabled: true
            },
            {
              key: "audit_remarks",
              name: () => this.$t("auditOrder") + this.$t("Remarks"),
              component: "Input",
              placeholder() {
                return this.$t("auditOrder") + this.$t("Remarks");
              },
              disabled: true
            },
            {
              key: "audit_status",
              name: () => this.$t("auditOrder") + this.$t("exlType"),
              component: "Radio",
              placeholder() {
                return this.$t("auditOrder") + this.$t("exlType");
              },
              bind: {
                border: true
              },
              options: [
                { label: this.$t("go_to_review"), value: 1 },
                { label: this.$t("not_through"), value: 2 },
                { label: this.$t("through"), value: 3 }
              ],
              show({ row }) {
                return row.audit_status != 30;
              }
            },
            {
              name: this.$tz("不通过,原因"),
              key: "reason_id",
              component: "Select",
              placeholder: () => this.$tz("不通过,原因"),
              options: [],
              optionsFn: "getCommon",
              apiData: {
                apiType: "reason"
              },
              optionsKey: "",
              show({ row }) {
                return row.audit_status == 2;
              },
              default: ""
            },
            {
              key: "u_tag",
              name: () => this.$t("label"),
              component: "Radio",
              placeholder() {
                return this.$t("select") + this.$t("label");
              },
              bind: {
                border: true
              },
              options: [
                { label: this.$t("ordinary"), value: 1 },
                { label: this.$t("special"), value: 2 }
              ]
            },
            {
              key: "remarks",
              name: () => this.$t("Remarks"),
              component: "Input",
              bind: {
                type: "textarea",
                rows: 3
              },
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
              show({ row }) {
                return row.audit_status != 30;
              }
            },
            {
              key: "special_remarks",
              name: () => this.$t("special_remark"),
              component: "Input",
              bind: {
                type: "textarea",
                rows: 3
              },
              placeholder() {
                return this.$t("special_remark");
              },
              disabled: true
            }
          ]
        },
        add: {
          contentSlot: "ADDMODAL",
          config: {
            modalBind: {
              width: 1500,
              draggable: true
            }
          },
          footer: {
            show: () => false
          }
        },
        Service: {
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({ id: row.id });
              console.log(data);
              this.$page
                .handleRequestMethods("saveUserBindInfo", data)
                .then(res => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg
                  });
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            modalBind: {
              width: 600
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [
            { group_name: 24 },
            { customer_service_id: 24 },
            { dbl_customer_service_id: 24 },
            { op_customer_service_id: 24 },
            { branch_customer_service_id: 24 }
          ],
          fields: [
            {
              key: "group_name",
              name: () => this.$t("group_name1"),
              component: "Input",
              placeholder: () => this.$t("group_name1")
            },
            {
              key: "customer_service_id",
              name: () => this.$t("serviceName"),
              component: "Select",
              options: [],
              placeholder: () => this.$t("serviceName"),
              methods: {
                list: ({ field }) =>
                  (field.options = this.selectData["customerServiceId"])
              }
            },
            {
              key: "dbl_customer_service_id",
              name: () => this.$t("delService"),
              component: "Select",
              options: [],
              placeholder: () => this.$t("delService"),
              methods: {
                list: ({ field }) =>
                  (field.options = this.selectData["dblServiceList"])
              }
            },
            {
              key: "op_customer_service_id",
              name: () => this.$t("operation") + this.$t("service"),
              component: "Select",
              options: [],
              placeholder: () => this.$t("operation") + this.$t("service"),
              methods: {
                list: ({ field }) =>
                  (field.options = this.selectData["operateList"])
              }
            },
            {
              key: "branch_customer_service_id",
              name: () => this.$t("branchOffice") + this.$t("service"),
              component: "Select",
              options: [],
              placeholder: () => this.$t("branchOffice") + this.$t("service"),
              methods: {
                list: ({ field }) =>
                  (field.options = this.selectData["branchServiceList"])
              }
            }
          ]
        },
        bindFreight: {
          contentSlot: "Freight",
          config: {
            modalBind: {
              width: 80,
              draggable: true,
              styles: {
                top: "50px"
              }
            }
          },
          footer: {
            show: () => false
          }
        },
        bindContract: {
          contentSlot: "Contract",
          config: {
            modalBind: {
              width: 80,
              draggable: true,
              styles: {
                top: "30px"
              }
            }
          },
          header: {
            show: () => true,
            btns: [
              {
                name: () => this.$t("addContract"),
                key: "add",
                fnName: "add",
                bind: {
                  icon: "md-add",
                  type: "warning",
                  style: {
                    margin: "0 10px"
                  }
                },
                id: 99
              }
            ],
            methods: {
              add: () => {
                this.$refs["contract"].open();
              }
            }
          },
          footer: {
            show: () => false
          }
        },
        whitelist: {
          contentSlot: "Whitelist",
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            title: this.$t("whitelist")
          },
          footer: {
            show: () => false
          }
        },
        updatePwd: {
          methods: {
            ok({ row, close }) {
              delete row.confirmPwd;
              delete row.account;
              this.$page.handleRequestMethods("updatePwd", row).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              maskClosable: false
            },
            title: this.$t("updatePwd"),

            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              shipper_password: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              confirmPwd: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                },
                {
                  validator: (rule, value, callback) => {
                    this.$nextTick(() => {
                      if (
                        value !=
                        this.getModalFormData("updatePwd").shipper_password
                      ) {
                        return callback(new Error(this.$t("Thetwopasswords")));
                      }
                      callback();
                    });
                  },
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ account: 24 }, { shipper_password: 24 }, { confirmPwd: 24 }],
          fields: [
            {
              key: "account",
              name: () => this.$t("account"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("account");
              },
              disabled: true
            },
            {
              key: "shipper_password",
              name: () => this.$t("password"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("password");
              },
              bind: {
                type: "password",
                password: true
              },
              methods: {
                "on-change"({ formData }) {
                  formData.confirmPwd = "";
                }
              }
            },
            {
              key: "confirmPwd",
              name: () => this.$t("confirmPwd"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("password");
              },
              bind: {
                type: "password",
                password: true
              }
            }
          ]
        },
        log: {
          footer: {
            show() {
              return false;
            }
          },
          config: {
            listFn: "getLog",
            modalBind: {
              width: 800,
              draggable: true,
              maskClosable: true
            }
          },
          table: {
            header: {
              show: () => true,
              config: {
                custom: false
              },
              searchs: [
                {
                  key: "keywords",
                  placeholder() {
                    return this.$t("keyword");
                  },
                  component: "Input"
                  // bind: {
                  //   type: "textarea",
                  //   autosize: { minRows: 2, maxRows: 2 }
                  // }
                }
              ]
            },
            config: {
              height: 600,
              showOverflow: false
            },
            footer: {
              show() {
                return true;
              }
            },
            fields: [
              {
                name: () => this.$t("operate"),
                key: "operate_name",
                width: 150
              },
              {
                name: () => this.$t("operation") + this.$t("content"),
                key: "operate_content",
                align: "left",
                type: "html"
                // minWidth: 150,
                // render(h, { row }) {
                //   return h("span", {
                //     props: {
                //       innerHtml: row.operate_content,
                //     },
                //   });
                // },
              },
              {
                name: () => this.$t("operation") + this.$t("time"),
                key: "operate_time",
                width: 170
              }
            ]
          }
        }
      },
      header: {
        config: {
          custom: true,
          searchLength: 13
        },
        searchs: [
          {
            key: "startTime",
            placeholder() {
              return this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "130px"
              }
            }
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "130px"
              }
            }
          },
          {
            key: "status",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("exlType");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:110px"
            }
          },
          {
            key: "un_bind",
            component: "Select",
            placeholder() {
              return (
                this.$t("whether") + this.$t("not_bound") + this.$t("service")
              );
            },
            clearable: true,
            options: [
              { label: this.$t("YES"), value: 1 },
              { label: this.$t("NO"), value: 2 }
            ],
            bind: {
              style: "width:130px"
            }
          },
          {
            key: "is_error_value",
            component: "Select",
            placeholder() {
              return this.$tz("重量误差");
            },
            clearable: true,
            options: [
              { label: this.$tz("启用"), value: 1 },
              { label: this.$tz("禁用"), value: 0 }
            ],
            bind: {
              style: "width:130px"
            }
          },
          {
            key: "customerServiceId",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("serviceAccount");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:150px"
            }
            // methods: {
            //   async list({ field, searchForm }) {
            //     let res = (await getAllService()).data.payload;
            //     field.options = [].concat(res[1]).concat(res[2]).concat(res[3]);
            //     this.$forceUpdate();
            //   },
            // },
          },
          {
            key: "salesmanId",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            clearable: true,
            options: [],

            bind: {
              style: "width:150px"
            }
          },
          {
            key: "chargePeriod",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("period");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "platform",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientCompany");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "delivery",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("delivery_mode");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "ownership",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("ownership");
            },
            clearable: true,
            options: [],
            config: { label: "title", value: "id" },
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "c_title",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("contract_title");
            },
            clearable: true,
            options: [],
            config: { label: "title", value: "id" },
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "active",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("activeStatus");
            },
            clearable: true,
            options: [
              { label: this.$t("active"), value: 1 },
              { label: this.$t("inactive"), value: 2 }
            ],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "ddx",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("DDX");
            },
            clearable: true,
            options: [
              { label: this.$t("DDU"), value: "DDU" },
              { label: this.$t("DDP"), value: "DDP" }
            ],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "fit",
            placeholder() {
              return this.$tz("是否,散客");
            },
            component: "Select",
            options: [],
            optionsFn: "YesNoNumber",
            optionsKey: ""
          },
          {
            key: "audit_status",
            placeholder() {
              return this.$tz("审核状态");
            },
            component: "Select",
            options: [],
            optionsFn: "audit_status",
            optionsKey: ""
          },
          {
            key: "reason_id",
            placeholder() {
              return this.$tz("不通过,原因");
            },
            component: "Select",
            options: [],
            optionsFn: "getCommon",
            apiData: {
              apiType: "reason"
            }
          },
          {
            key: "min",
            placeholder() {
              return this.$tz("最小,信用额度");
            },
            component: "Input"
          },
          {
            key: "max",
            placeholder() {
              return this.$tz("最大,信用额度");
            },
            component: "Input"
          },
          {
            key: "keywords",
            placeholder() {
              return (
                this.$t("account") +
                "|" +
                this.$t("shipper_company") +
                this.$t("shipper_company_cn") +
                "|" +
                this.$t("group_name1")
              );
            },
            component: "Input",
            bind: {
              style: "width:260px",
              type: "textarea",
              autosize: { minRows: 1, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 93
            },
            {
              name: () =>
                this.$t("batch") + this.$t("enable") + this.$t("disable"),
              type: "openStatusModal",
              fnName: "openStatusModal",
              bind: {
                type: "primary"
              },
              disabled() {
                return !this.selectAll.length;
              },
              id: 830
            },
            {
              name: () =>
                this.$t("batch") + this.$t("setting") + this.$t("personnel"),
              type: "updateUserModal",
              fnName: "updateUserModal",
              bind: {
                type: "primary"
              },
              disabled() {
                return !this.selectAll.length;
              },
              id: 831
            },

            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              // disabled() {
              //   return !this.selectAll.length;
              // },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            },
            {
              name: () => this.$tz("注册链接"),
              type: "register",
              fnName: "register",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$tz("批量,设置,散客"),
              type: "setFit",
              fnName: "batchSetting",
              bind: {
                type: "primary"
              },
              id: 1815,
              disabled() {
                return !this.selectAll.length;
              }
            },
            {
              name: () => this.$tz("批量,设置,结算周期"),
              type: "setBillingCycle",
              fnName: "batchSetting",
              bind: {
                type: "primary"
              },
              id: 1814,
              disabled() {
                return !this.selectAll.length;
              }
            },
            {
              name: () => this.$tz("批量,设置,信用额度"),
              type: "setCreditLimit",
              fnName: "batchSetting",
              bind: {
                type: "primary"
              },
              id: 1813,
              disabled() {
                return !this.selectAll.length;
              }
            }
          ],
          methods: {
            batchSetting({ field }) {
              this.getModal("batchSetting").open(
                { ids: this.selectAll.map(t => t.id), type: field.type },
                function() {
                  this.setTitle(field.name());
                }
              );
            },
            register() {
              this.handleRequestMethods("fitUserRegUrl").then(res => {
                this.copy(res.payload);
              });
            },
            export({ searchForm }) {
              let data = searchForm;
              if (data.startTime)
                data.createTimeRange =
                  data.startTime + (data.endTime ? "," + data.endTime : "");
              data.export = 1;
              data.ids = this.selectAll.map(item => item.id);
              this.openLoading();
              this.handleRequestMethods("list", data).then(res => {
                window.open(this.$globalUrl + res.payload, "_blank");
                this.closeLoading();
              });
            },
            add() {
              let row = {
                disabled: false,
                text: "add",
                bank: [
                  {
                    location: "PRC",
                    bank_account_number: "",
                    account_name: "",
                    bank_address: "",
                    bank_code: "",
                    swift_code: "",
                    bank_name: "",
                    is_selected: 0
                  },
                  {
                    location: "HK",
                    bank_account_number: "",
                    account_name: "",
                    bank_address: "",
                    bank_code: "",
                    swift_code: "",
                    bank_name: "",
                    is_selected: 0
                  }
                ]
              };
              this.getModal("add").open(row, () => {
                this.getModal("add").setTitle(this.$t("add"));
              });
            },
            openStatusModal() {
              this.getModal("statusModal").open();
            },
            updateUserModal() {
              this.getModal("updateUser").open();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          width: 150,
          methods: {
            render({ value }) {
              return value > 1 ? this.format.timeFormat(value * 1000) : " ";
            }
          }
        },
        {
          name: () => this.$t("account"),
          key: "account",
          align: "left",
          minWidth: 100,
          type: "toolbar"
        },
        {
          name: () => this.$tz("额度风控"),
          key: "lock_status_txt",
          minWidth: 110,
          bind: {
            style({ row }) {
              if (row.lock_status == 1) {
                return { color: "red" };
              }
            }
          }
        },
        {
          name: () => this.$tz("手机号码"),
          key: "account_phone",
          align: "left",
          minWidth: 100,
          type: "toolbar"
        },
        {
          name: () => this.$t("fabAccount") + this.$t("exlType"),
          key: "status",
          width: 80,
          methods: {
            render: ({ value, field }) => {
              return (
                this.selectData[field.key] &&
                this.selectData[field.key].find(item => item.value == value)
                  .label
              );
            }
          }
        },
        {
          name: () => this.$t("activeStatus"),
          key: "active",
          width: 80,
          render: (h, { row }) => {
            return h("div", [
              h(
                row.active ? "Button" : "span",
                {
                  props: {
                    type: "success",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      if (row.active) {
                        this.$refs["table"]
                          .getModal("shippingStatus")
                          .open(row.active, function() {
                            this.setTitle(
                              this.$t("activeStatus") + "(" + row.account + ")"
                            );
                          });
                      }
                    }
                  }
                },
                row.active ? this.$t("active") : this.$t("inactive")
              )
            ]);
          }
        },
        {
          name: () => this.$t("auditOrder") + this.$t("exlType"),
          key: "audit_status_txt",
          width: 80,
          render: (h, { row }) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type:
                      row.audit_status == 11 || row.audit_status == 21
                        ? "error"
                        : row.audit_status == 30
                        ? "default"
                        : row.audit_status == 20
                        ? "warning"
                        : "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      row.remarks = "";
                      row.days = row.auditRemark?row.auditRemark.days:''
                      this.$refs["table"]
                        .getModal("audit")
                        .open(row, function() {
                          this.temp = row.audit_status == 30 ? false : true;
                          this.setTitle(
                            this.$t("auditOrder") + "(" + row.account + ")"
                          );
                        });
                    }
                  }
                },
                row.audit_status_txt
              )
            ]);
          }
        },
        {
          name: () => this.$tz("不通过,原因"),
          key: "reason_txt",
          minWidth: 120
        },
        {
          name: () => this.$t("label"),
          key: "u_tag_txt",
          width: 80
        },
        {
          name: () => this.$t("DDX"),
          key: "dd_type",
          width: 80
        },
        {
          name: () => this.$tz("重量误差"),
          key: "is_error_value",
          width: 80,
          methods: {
            render({ value }) {
              return value ? this.$tz("启用") : this.$tz("禁用");
            }
          }
        },
        {
          name: () => this.$tz("散客"),
          key: "fit",
          width: 100
        },
        {
          name: () => this.$t("special_remark"),
          key: "special_remarks",
          minWidth: 100,
          align: "left"
        },
        {
          name: () => this.$t("group_name1"),
          key: "group_name",
          minWidth: 130,
          align: "left"
        },
        {
          name: () => this.$t("ownership"),
          key: "ownershipInfo",
          minWidth: 150,
          align: "left",
          methods: {
            render({ value }) {
              return value && value.title;
            }
          }
        },
        {
          name: () => this.$t("shipper_company"),
          key: "shipper_company",
          minWidth: 130,
          align: "left"
        },
        {
          name: () => this.$t("shipper_company_cn"),
          key: "shipper_company_cn",
          minWidth: 100,
          align: "left"
        },
        {
          name: () => this.$t("shipper_company_en"),
          key: "shipper_company_en",
          minWidth: 100,
          align: "left"
        },
        {
          name: () => this.$t("contract_title"),
          key: "mainContractHeader",
          minWidth: 110,
          align: "left",
          methods: {
            render({ value }) {
              return value && value.title;
            }
          }
        },
        // {
        //   name: () => this.$t("spare_contract_header"),
        //   key: "spareContractHeader",
        //   minWidth: 110,
        //   align: "left",
        //   methods: {
        //     render({ value }) {
        //       return value && value.title;
        //     }
        //   }
        // },
        {
          name: () => this.$t("period"),
          key: "billing_cycle",
          width: 80,
          methods: {
            render: ({ value }) => {
              return (
                this.selectData["chargePeriod"] &&
                this.selectData["chargePeriod"].find(
                  item => item.value == value
                ).label
              );
            }
          }
        },
        {
          name: () => this.$tz("信用额度"),
          key: "credit_limit",
          minWidth: 110
        },
        {
          name: () => this.$t("account_balances"),
          key: "account_balances",
          width: 80
        },
        {
          name: () => this.$t("balance_amount"),
          key: "finance_bill_sum",
          width: 80
        },
        {
          name: () => this.$t("salesman"),
          key: "salesman",
          minWidth: 80,
          methods: {
            render({ value }) {
              return value && value.account;
            }
          }
        },
        {
          name: () => this.$t("Finance of Guangzhou Hq (Freight: small bag)"),
          key: "accounting",
          minWidth: 80,
          methods: {
            render({ value }) {
              return value && value.account;
            }
          }
        },
        {
          name: () => this.$t("serviceName"),
          key: "service",
          minWidth: 80,
          methods: {
            render({ value }) {
              return value && value.account;
            }
          }
        },
        {
          name: () => this.$tz("沙特,B2B客服"),
          key: "dblService",
          minWidth: 80,
          methods: {
            render({ value }) {
              return value && value.account;
            }
          }
        },
        {
          name: () => this.$tz("非沙特,B2B客服"),
          key: "ae_dbl_customer_service",
          minWidth: 80
        },
        {
          name: () => this.$t("operation") + this.$t("service"),
          key: "operateman",
          minWidth: 80,
          methods: {
            render({ value }) {
              return value && value.account;
            }
          }
        },
        {
          name: () => this.$t("branchOffice") + this.$t("service"),
          key: "branchService",
          minWidth: 100,
          methods: {
            render({ value }) {
              return value && value.account;
            }
          }
        },

        {
          name: () => this.$t("login") + this.$t("time"),
          key: "login_time",
          width: 150,
          align: "left"
        },
        {
          name: () => this.$t("PortalFinancialModule"),
          key: "show_finance",
          component: "i-switch",
          bind: {
            "true-value": 1,
            "false-value": 2
          },
          disabled: false,
          width: 150,
          align: "center",
          methods: {
            "on-change"({ field, value, row }) {
              field.disabled = true;
              console.log("on-change", field, value);
              this.$page
                .handleRequestMethods("showFinance", {
                  id: row.id,
                  show_finance: value
                })
                .then(res => {
                  field.disabled = false;
                  this.$Message.success({
                    content: "Success",
                    background: true
                  });
                })
                .catch(err => {
                  field.disabled = false;
                });
            }
          }
        },
        {
          type: "btns",
          width: 100,
          name: () => this.$t("operation"),
          fixed: "right",
          down: true,
          btnBind: {
            type: "primary",
            size: "small"
          },
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("show"),
              type: "show",
              fnName: "show"
            },

            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 94
            },
            {
              name: () => this.$t("Association Service"),
              type: "Service",
              fnName: "Service",
              bind: {
                type: "success"
              },
              id: 1436
            },
            {
              name: () => this.$t("update") + this.$t("bankInfo"),
              type: "updateBank",
              fnName: "updateBank",
              bind: {
                type: "success"
              },
              id: 1280
            },
            {
              name: () => this.$t("bindFreight"),
              type: "bindFreight",
              fnName: "bindFreight",
              bind: {
                type: "error"
              },
              id: 95
            },
            {
              name: () => this.$t("bindContract"),
              type: "bindContract",
              fnName: "bindContract",
              bind: {
                type: "info"
              },
              id: 98
            },
            {
              name: () => this.$t("whitelist"),
              type: "whitelist",
              fnName: "whitelist",
              bind: {
                type: "warning"
              },
              id: 105
            },
            {
              name: () => this.$t("企微机器人"),
              type: "robot",
              fnName: "robot",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$t("updatePwd"),
              type: "updatePwd",
              fnName: "updatePwd",
              id: 106
            },
            {
              name: () => this.$t("updateLog"),
              type: "updateLog",
              fnName: "updateLog",
              bind: {
                type: "success"
              }
            }
          ],

          methods: {
            robot({ row }) {
              this.getModal("robot").open(row, function() {
                this.setTitle(row.account + "(" + this.$t("企微机器人") + ")");
              });
            },
            Service({ row }) {
              this.handleRequestMethods("getDetails", row.id, false, true).then(
                res => {
                  res.payload.Service = true;
                  this.getModal("Service").open(res.payload, function() {
                    this.setTitle(
                      row.account + "(" + this.$t("Association Service") + ")"
                    );
                  });
                }
              );
            },
            show({ row }) {
              this.handleRequestMethods("getDetails", row.id, false, true).then(
                res => {
                  let data = res.payload;
                  data.disabled = true;
                  this.getModal("add").open(data, function() {
                    this.setTitle(row.account + "(" + this.$t("show") + ")");
                  });
                }
              );
            },
            updateBank({ row }) {
              this.handleRequestMethods("getDetails", row.id, false, true).then(
                res => {
                  res.payload.isBank = true;
                  this.getModal("add").open(res.payload, function() {
                    this.setTitle(
                      row.account +
                        "(" +
                        this.$t("update") +
                        this.$t("bankInfo") +
                        ")"
                    );
                  });
                }
              );
            },
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id, false, true).then(
                res => {
                  this.getModal("add").open(res.payload, function() {
                    this.setTitle(row.account + "(" + this.$t("update") + ")");
                  });
                }
              );
            },
            bindFreight({ row }) {
              // this.handleRequestMethods("getDetails", row.id).then(res => {
              this.getModal("bindFreight").open(row, function() {
                this.setTitle(row.account + "(" + this.$t("bindFreight") + ")");
              });
              // });
            },
            bindContract({ row }) {
              // this.handleRequestMethods("getDetails", row.id).then(res => {
              this.getModal("bindContract").open(row, function() {
                this.setTitle(
                  this.$t("b2bClient") +
                    "(" +
                    row.account +
                    ")" +
                    this.$t("bindContract")
                );
              });
              // });
            },
            whitelist({ row }) {
              this.getModal("whitelist").open(row, function() {
                this.setTitle(row.account + "(" + this.$t("whitelist") + ")");
              });
            },

            updatePwd({ row }) {
              let data = {
                account: row.account,
                id: row.id,
                confirmPwd: "",
                shipper_password: ""
              };
              this.getModal("updatePwd").open(data, function() {
                this.setTitle(row.account + "(" + this.$t("updatePwd") + ")");
              });
            },
            updateLog({ row }) {
              this.getModal("log").open({}, function() {
                this.pageConfig.data = { id: row.id };
                this.getList();
                this.setTitle(row.account + "(" + this.$t("updateLog") + ")");
              });
            }
          }
        }
      ]
    };
  },
  async mounted() {
    let data = (await getAllService()).data.payload;
    this.selectData = {
      status: [
        { label: this.$t("enable"), value: "ENABLE" },
        { label: this.$t("disable"), value: "DISABLE" }
      ],
      chargePeriod: [
        { label: this.$t("month"), value: "MONTH" },
        { label: this.$t("half_moon"), value: "HALFMONTH" },
        { label: this.$t("week"), value: "WEEK" },
        { label: this.$t("day"), value: "DAY" }
      ],
      customerServiceId: []
        .concat(data[1])
        .concat(data[2])
        .concat(data[3]),
      salesmanId: data[5],
      accountingList: data[6],
      dblServiceList: data[2],
      operateList: data[3],
      branchServiceList: data[4],
      platform: (await getPlatform()).data.payload.map(t => ({
        label: t,
        value: t
      })),
      delivery: (await getDeliverType()).data.payload.map(t => ({
        label: t,
        value: t
      })),
      ownership: (await getCompanies()).data.payload,
      c_title: (await getContractParams()).data.payload.header,
      branch_finance: data[12],
      currency: (await getCurrency({ pageSize: 9999 })).data.payload.rows
    };
    this.header.searchs.forEach(item => {
      if (item.key && this.selectData[item.key]) {
        item.options = this.selectData[item.key];
      }
    });
  },
  methods: {
    // 获取页面弹窗中的form表单数据
    getModalFormData(text) {
      return this.$refs["table"].getModal(text).$refs["form"].formData;
    }
  }
};
</script>
